import React from "react";
import { CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import ButtonDialog from "default/components/ButtonDialog";
import StyledButton from "default/components/StyledButton";

const DEFAULT_CONTROL = {
  button_label: "次の章へ進む",
  confirm_title: "次の章に進みますか？",
  warning_text: "次の章に進むと、現在の章には戻れません。",
};

const NextPhaseSection = ({ nextPhase, control = null }) => {
  const { t } = useTranslation(["common"]);
  const { isLoading, errorMessage } = nextPhase;
  const copy = control || DEFAULT_CONTROL;

  const warning = (
    <Typography
      sx={(theme) => ({
        textAlign: "center",
        fontSize: 13,
        fontWeight: "bold",
        color: theme.system.colors.text.warning,
        whiteSpace: "pre-line",
      })}
    >
      {copy.warning_text}
    </Typography>
  );

  return (
    <>
      <StyledButton
        variant="contained"
        disabled={isLoading}
        onClick={nextPhase.handlers.onClickProceed}
        sx={(theme) => ({
          marginTop: 4,
          background: "transparent",
          color: theme.system.colors.red,
          borderColor: theme.system.colors.red,
        })}
      >
        {copy.button_label}
      </StyledButton>

      <ButtonDialog
        open={nextPhase.dialogStates.openConfirm}
        title={copy.confirm_title}
        content={warning}
        buttons={[
          {
            label: isLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              copy.button_label
            ),
            disabled: isLoading,
            onClick: nextPhase.handlers.onClickConfirm,
          },
        ]}
        handleClose={isLoading ? () => {} : nextPhase.handlers.onClickClose}
        showCloseButton={!isLoading}
      />

      <ButtonDialog
        open={nextPhase.dialogStates.openError}
        title={"エラーが発生しました"}
        description={errorMessage}
        buttons={[
          {
            label: `${t("common:button.close")}`,
            onClick: nextPhase.handlers.onClickClose,
          },
        ]}
        handleClose={nextPhase.handlers.onClickClose}
      />
    </>
  );
};

export default NextPhaseSection;
